import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';

export const planSelectionRadioEnums = {
  HAS_LINE_IN_OTHER_COMPANY: {title: 'יש לי קו בחברה אחרת ואני רוצה לנייד לתוכנית צה"ל', value: 3},
  INTRESTED_IN_NEW_LINE: {title: 'אני מעוניין בקו חדש', value: 1},
  HAS_LINE_IN_CELLCOM: {title: 'יש לי קו בסלקום ואני מעוניין לצרפו לתוכנית צה"ל', value: 2},
};

export const steps = [
  {value: ['PlanSelection'], title: 'בחירת תוכנית', showInStepBar: true, available: true},
  {value: ['PersonalInfo', 'PaymentInfo'], title: 'פרטים אישיים', showInStepBar: true, available: true},
  {value: ['DeviceSelection', 'DeviceSelectionStep2'], title: 'בחירת מכשיר', showInStepBar: true, available: true},
  {value: ['DeliveryDateStep1', 'DeliveryDateStep2'], title: 'מועד אספקה', showInStepBar: true, available: true},
  {value: ['OrderSummary'], title: 'סיכום הזמנה', showInStepBar: true, available: true},
];

export enum PathHistory {
  PlanSelection = 'PlanSelection',
  PersonalInfo = 'PersonalInfo',
  PaymentInfo = 'PaymentInfo',
  DeviceSelectionStep1 = 'DeviceSelection',
  DeviceSelectionStep2 = 'DeviceSelectionStep2',
  DeliveryDateStep1 = 'DeliveryDateStep1',
  DeliveryDateStep2 = 'DeliveryDateStep2',
  OrderSummary = 'OrderSummary',
}

export const SimHistory = [
  PathHistory.PlanSelection,
  PathHistory.PersonalInfo,
  PathHistory.PaymentInfo,
  PathHistory.DeviceSelectionStep1,
  PathHistory.DeliveryDateStep1,
  PathHistory.DeliveryDateStep2,
  PathHistory.OrderSummary,
];
export const EsimHistory = [
  PathHistory.PlanSelection,
  PathHistory.PersonalInfo,
  PathHistory.PaymentInfo,
  PathHistory.DeviceSelectionStep1,
  PathHistory.OrderSummary,
];
export const UpgradeHistory = [
  PathHistory.DeviceSelectionStep1,
  PathHistory.DeviceSelectionStep2,
  PathHistory.DeliveryDateStep1,
  PathHistory.DeliveryDateStep2,
  PathHistory.OrderSummary,
];

export const DATA_TRANSFER_ENUM = {
  BY_LAW: {state: 'move_data_by_law', title: 'יורשיי על פי דין'},
  TO_PERSON: {state: 'move_data_to_person', title: 'אדם אחר'},
  DONT_MOVE: {state: 'dont_move_data', title: 'אינני מרשה לגורמי צה״ל להעביר את המידע האגור בטלפון הנייד לאף גורם'},
};
// export const INPUT_TYPE = {
//   PHONE: 'PHONE',
//   EMAIL: 'EMAIL',
//   POSTAL_CODE: 'POSTAL_CODE',
//   UNKNOWN: 'UNKNOWN',
// };
export enum INPUT_TYPE {
  PHONE, // 0
  EMAIL, // 1
  POSTAL_CODE, // 2
  UNKNOWN, // 3
  ID, // 5
  TEXT_FIELD, // 6
  NUMBER_FIELD,
}

export enum EsimTextEnum {
  NiudEsim = 0,
  NiudEsimWithModel = 1,
  NewLineEsim = 2,
  NewLineEsimWithModel = 3,
}

export const ErrorCode = {
  7: '14342',
  8: '14343',
  9: '14344',
  98: '1434',
  99: '14341',
  62: '0621',
  667: '6671',
};

export function formatActivityHours(activityHours) {
  return activityHours.replace(/<[^>]*>/g, ', ');
}
export function getPage(currentPage, action, store) {
  switch (currentPage) {
    case steps[4].value:
      if (action) {
        return '';
      } else {
        if (store.processType === 'SIM' && store.lineType == 2) {
          return steps[2].value;
        }
      }
      console.log(store);
      break;
    case steps[2].value:
      if (store.processType === 'SIM' && store.lineType == 2) {
        return steps[4].value;
      }
      break;
    default:
      break;
  }
}
export const convertPackageTitle = (packageTitle) => {
  const tempElement = document.createElement('div');

  tempElement.innerHTML = packageTitle;

  const textContent = tempElement.textContent || tempElement.innerText;
  return textContent;
};
export const GetCreditCardTypeId = (CCType) => {
  var ccType = '';
  switch (CCType) {
    case '1':
      ccType = 'Isracard';
      break;
    case '2':
      ccType = 'Visa';
      break;
    case '3':
      ccType = 'Diners';
      break;
    case '4':
      ccType = 'American Express';
      break;
    case '6':
      ccType = 'Luxury Card';
      break;
  }

  return ccType;
};

export const LEASING_TEXT = [
  'דקות שיחה לכל הרשתות המפ״א / סלולר בישראל לא כולל חיוג ליעדים מיוחדים בתעריף מיוחד כדוגמת 144 / 1-900 וכדומה',
  'היקף דקות השיחה המקסימלי הכולל בחבילה יעמדו על 7,500 דקות שיחה יוצאות בחודש',
  'בהיקף דקות זה יכללו יעדים בקידומת 1-800 ומספרים מקוצרים לעסקים המתחילים בכוכבית',
  'משלוח הודעות  SMS ו- MMS לכל רשתות הסלולר בישראל עד 7,500 הודעות     יוצאות לחודש',
  'חבילת גלישה בהתאם לזכאות במדרג, בסיום חבילת הגלישה תחול האטה    משמעותית בגלישה',
  'הנך זכאי/ת לקבל מכשירבמסלול ליסינג ךתקופת התחייבות מינימלית של 18 חודשים. לאחר תקופה זו, תוכל להחליף מכשיר ולהצטרף למסלול ליסינג נוסף, בהתאם    לתנאים אשר יעודכנו מעת לעת. קבלת מכשיר בליסינג מותנית בהצטרפות לתוכנית במסגרת ההסכם.',
  'בתום תקופת הליסינג תוכל/י להחזיר את המכשיר לסלקום או לרכוש אותו בהתאם למחירון שיקבע ע״י סלקום, וכן לבצע ליסינג נוסף לתקופה של 18 חודשים',
  'שים לב במקרים של שחרור / פרישה יש להחזיר את המכשיר לחברת סלקום, או לחלופין לרכוש את המכשיר ע״פ המחירון שיקבע ע״י סלקום',
  'מסלול זה ניתן ללא עלות לדרג א׳, אשר זכאים לקבל מכשיר מבין הדגמים המוצעים עבורם בתוכנית זו',
];

export const isAllowedEsim = ({store, esimFlag}) => {
  return store.lineType != 2 && esimFlag; // TBD
};

export const isNoDeliveryProccess = (store) => {
  return !store.deviceUpgradeProcessing && store.processType === 'SIM' && store.simType === 'eSIM';
};

export const getCurrentHistory = (store) => {
  if (store.deviceUpgradeProcessing) {
    return UpgradeHistory;
  } else {
    if (store.processType === 'SIM') {
      var SkipDeliveryStep = store.simType === 'eSIM' || store.lineType == 2;
      if (SkipDeliveryStep) {
        return EsimHistory;
      } else {
        return SimHistory;
      }
    }
    return Object.values(PathHistory);
  }
};

export const getPreviousPage = (store, config) => {
  let enumValues: any = Object.values(getCurrentHistory(store));
  let currentIndex = enumValues.indexOf(store.steps.current);
  let index = currentIndex - 2;
  if (index == -2) {
    prepareSameWindowUrlWithNavigateTo(config.idfHomePageUrl);
    return '';
  } else {
    return enumValues[index];
  }
};
